var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperJ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 62,
    viewBox: "0 0 35 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4805 0.23999H32.9805V2.73999H34.4805V0.23999ZM15.2511 61.59L15.2411 61.5892L15.3611 60.09C13.7511 59.97 12.2611 59.66 10.9211 59.17L10.4111 60.58C11.8783 61.119 13.4949 61.4487 15.2411 61.5892L15.2411 61.59H15.2511ZM23.0611 60.82L22.6111 59.39C24.0911 58.93 25.4411 58.25 26.6111 57.38L27.5111 58.58C26.2011 59.55 24.7111 60.31 23.0611 60.82ZM3.99105 55.94C3.02105 54.69 2.21105 53.23 1.58105 51.6L2.98105 51.06C3.56105 52.55 4.30105 53.88 5.18105 55.02L4.00105 55.94H3.99105ZM32.3611 52.34L30.9911 51.73C31.5811 50.41 32.0511 48.94 32.3811 47.35L33.8511 47.66C33.4911 49.35 32.9911 50.93 32.3611 52.34ZM32.9811 39.94V35.14H34.4811V39.84L32.9811 39.94ZM34.4811 27.51H32.9811V22.74H34.4811V27.51ZM34.4811 15.12H32.9811V10.35H34.4811V15.12ZM0.0407533 41.33C0.0307533 41.37 -0.0392467 42.37 0.0307533 43.92L1.53075 43.85C1.45075 42.41 1.53075 41.45 1.53075 41.45L0.0407533 41.33Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperJ);
export default __webpack_public_path__ + "static/media/UPPER_J.00d32ab98cb937317c8b81dcdd2ebf60.svg";
export { ForwardRef as ReactComponent };